// @flow
import React, { useState } from 'react';
import RSelect from 'react-select';
import i18n from 'i18next';
import './styles.scss';

const options = [
  {
    label: (
      <div className="FlagLanguageWrapper">
        Eng
      </div>
    ),
    value: 'en',
  },
  {
    label: (
      <div className="FlagLanguageWrapper">
        Ru
      </div>
    ),
    value: 'ru',
  },
];

const LanguageSelect = () => {
  const lang = () => {
    if (i18n.language.includes('ru')) return 'ru';
    if (i18n.language.includes('en')) return 'en';
    return i18n.language;
  };
  const selectedLanguage = options.filter((lan) => lan.value === lang());

  const [value, setPosition] = useState<Object>(selectedLanguage[0]);

  const handlerSelect = (selected) => {
    setPosition(selected);
    i18n.changeLanguage(selected.value);
    window.location.reload();
  };

  return (
    <RSelect
      options={options}
      value={value}
      className="rsn__select"
      classNamePrefix="rsn"
      onChange={handlerSelect}
      readOnly
      isSearchable={false}
    />
  );
};

export default LanguageSelect;
